import { render, staticRenderFns } from "./opportunities-menu.vue?vue&type=template&id=7a827ad2&scoped=true"
import script from "./opportunities-menu.vue?vue&type=script&lang=js"
export * from "./opportunities-menu.vue?vue&type=script&lang=js"
import style0 from "./opportunities-menu.vue?vue&type=style&index=0&id=7a827ad2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a827ad2",
  null
  
)

export default component.exports